const BannerLoader = () => {
  return (
    <div className="h-[250px] w-full animate-pulse bg-gray-200 p-2 md:h-[350px]"></div>
  );
};

export default BannerLoader;
